import type { JSX } from 'react';

import { useNotificationCenterContext } from './NotificationCenterLayout';
import ConfigurationSection from './settings/ConfigurationSection';

const NotificationCenterSettingsPage = (): JSX.Element => {
  const { masterProject, subProjects } = useNotificationCenterContext();

  return (
    <ConfigurationSection
      key={masterProject.id}
      projectId={masterProject.id}
      businessRuleDisplayName={masterProject.name}
      subProjects={subProjects.map((subProject) => ({ id: subProject.id, name: subProject.name }))}
    />
  );
};

export default NotificationCenterSettingsPage;
